var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14528 13.2137C8.61961 13.6775 9.38993 13.6775 9.86426 13.2137L14.7214 8.46366C15.1957 7.99979 15.1957 7.24647 14.7214 6.78261C14.2471 6.31874 13.4768 6.31874 13.0024 6.78261L10.2172 9.50643L10.2172 1.6875C10.2172 1.03066 9.67453 0.499997 9.00288 0.499997C8.33122 0.499997 7.78859 1.03066 7.78859 1.6875L7.78859 9.50643L5.00332 6.78261C4.52899 6.31874 3.75868 6.31874 3.28435 6.78261C2.81002 7.24647 2.81002 7.99979 3.28435 8.46366L8.14149 13.2137L8.14528 13.2137Z",
    fill: "#1A2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92857 13.0227C2.92857 12.3062 2.38594 11.7273 1.71429 11.7273C1.04263 11.7273 0.5 12.3062 0.5 13.0227V15.6137C0.5 17.7592 2.1317 19.5 4.14286 19.5H13.8571C15.8683 19.5 17.5 17.7592 17.5 15.6137V13.0227C17.5 12.3062 16.9574 11.7273 16.2857 11.7273C15.6141 11.7273 15.0714 12.3062 15.0714 13.0227V15.6137C15.0714 16.3302 14.5288 16.9091 13.8571 16.9091H4.14286C3.47121 16.9091 2.92857 16.3302 2.92857 15.6137V13.0227Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4af2e8ccf6713929e2c61096700e7b4e.svg";
export { ForwardRef as ReactComponent };